import {NamaPresenter} from "./NamaPresenter";
import * as metadata from '../common/Metadata'
import {findActionsWithActionId, isTheSameLayout} from '../common/Metadata'
import {ListScreenView} from "../views/list/ListScreenLayout";
import * as cmn from '../common/NamaCommon';
import {areEqual, areNotEqual, getFirstNotNullObj, isAnyEqualToFirst, isEmptyOrNull, isNullOrUndefined} from '../common/NamaCommon';
import * as PreferencesRequest from '../constants/PreferencesRequest';
import * as NamaURLS from '../constants/NamaURLS';
import * as ViewMode from '../constants/ViewMode';
import {NamaRouterInstance} from "./NamaRouter";
import {EditPlace} from "./places";
import {ActionHandler} from "../widgets/ActionHandler";
import {of} from "../widgets/ActionPlaceholder";
import * as CommonFieldIds from "../constants/CommonFieldIds";
import {createGenericValueForList, createGenericValueForObject, list} from "../actions/GenericValues";
import {CriteriaExpressionSerializer, QuestionFieldsSerializer} from "../common/CriteriaAndQuestionsURLParser";
import {printList} from "../common/NaMaPrinting";
import * as PrintingOption from "../constants/PrintingOption";
import * as ClientCache from "../login/ClientCache";
import {getMenuLineBySrc, isPrintingPossible} from "../login/ClientCache";
import {deleteNotConfirmed, sendEmail_} from "../routing/EditPresenter";
import * as OutputFormat from "../constants/OutputFormat";
import {toCSVLineWithSep} from "../common/StringUtils";
import * as OwnerType from "../constants/OwnerType";
import * as SortType from "../constants/SortType";
import * as BusinessFunction from "../constants/BusinessFunction";
import {ActionPerformer} from "../widgets/ActionPerformer";
import {JSCriteriaBuilder} from "../common/JSCriteriaBuilder";
import * as BSEntities from "../constants/BSEntities";
import * as DomainBaseFieldIDs from "../constants/DomainBaseFieldIDs";
import * as ConstantViewNames from "../constants/ConstantViewNames";
import * as notifier from "../common/ErrorsNotification";
import {translateId, translateTitledIDWithPrefixes} from "../common/Translator";

function prepareDataParents(data) {
    if (!data.page || !data.page.length)
        return;
    for (let line of data.page) {
        let lineParent = line.values.parent;
        if (lineParent)
            line.values.gui2Parent = lineParent;
    }
}

export class ListPresenter extends NamaPresenter {

    start() {
        let that = this;
        that.hasMissingMetaData = true;
        /**
         * @type {namaTypes.FetchPreferencesRequest}
         */
        let req = {owner: {ownerType: OwnerType.Entity, ownerId: that.entityType}};
        req.properties = [PreferencesRequest.LIST_LAYOUT, PreferencesRequest.LIST_LAYOUT_PREFERENCES, PreferencesRequest.META_DATA, PreferencesRequest.VIEW_NAMES];
        if (that.place.listViewName) {
            req.listLayoutScreenName = that.place.listViewName;
        }
        that.viewNames = [];
        metadata.fetchPreferences(req, (preferences) => {
            if (!preferences.listLayout)
                return;
            that.preferences = preferences;
            that.metaData = that.preferences.metaData;
            that.hiddenQuestionFields = that.getHiddenQuestionsInListView(that.entityType, that.place.listViewName);
            that.place.ascending = that.isAscendingSort() + "";
            that.place.preferences = preferences;
            for (let viewName of preferences.viewNames) {
                if (viewName.type == "LIST" && (isNullOrUndefined(viewName.selectable) || viewName.selectable === true))
                    that.viewNames.push({value: viewName.id, text: translateTitledIDWithPrefixes(viewName, null)});
            }
            if (this.onLayoutFetched)
                this.onLayoutFetched(preferences.listLayout);
            this.startListView();
        });
    }

    setViewName(viewName) {
        let that = this;
        if (!isTheSameLayout(viewName, that.place.listViewName)) {
            that.place.listViewName = viewName;
            that.start();
        }
    }

    hideQuestionField(questionFieldId) {
        let that = this;
        if (questionFieldId.contains(",")) {
            let parts = questionFieldId.split(",");
            for (let q of parts) {
                that.hideQuestionField(q);
            }
        }
        if (!that.hiddenQuestionFields.contains(questionFieldId))
            that.hiddenQuestionFields.push(questionFieldId);
    }

    beforeGoToPlace() {
        let that = this;
        if (that.dialogBox)
            that.dialogBox.hide();
    }

    isAscendingSort() {
        let that = this;
        if (!that.preferences.listLayout.defaultSortType)
            return that.place.ascending;
        if (that.preferences.listLayout.defaultSortType === SortType.Ascending)
            return true;
        return false;
    }

    startListView() {
        let that = this;
        let listLayoutWrapper = that.embeddedListLayoutWrapper;
        if (!listLayoutWrapper) {
            $("#main-wrapper").find("#example.page-content-wrapper").remove();
            listLayoutWrapper = $(`<div id="example" class="page-content-wrapper"></div>`);
            listLayoutWrapper.appendTo("#main-wrapper");
        }
        that.view = new ListScreenView(that);
        that.view.render().appendTo(listLayoutWrapper);
        that.view.afterAttach();
    }

    revise(ids) {
        if (isEmptyOrNull(ids)) {
            notifier.showError(translateId("pleaseSelectRows"));
            return;
        }
        cmn.ajaxJSON(NamaURLS.BULK_REVISE, {
            entityType: this.entityType,
            id: toCSVLineWithSep(",", ids),
            revise: true
        }, () => this.onRefresh(), () => this.onRefresh())
    }

    unRevise(ids) {
        if (isEmptyOrNull(ids)) {
            notifier.showError(translateId("pleaseSelectRows"));
            return;
        }
        cmn.ajaxJSON(NamaURLS.BULK_REVISE, {
            entityType: this.entityType,
            id: toCSVLineWithSep(",", ids),
            revise: false
        }, () => this.onRefresh(), () => this.onRefresh())
    }

    bulkDeleteEntities(ids) {
        if (deleteNotConfirmed())
            return;
        cmn.ajaxJSON(NamaURLS.BULK_DELETE, {
            entityType: this.entityType,
            id: toCSVLineWithSep(",", ids),
            code: ""
        }, () => this.onRefresh(), () => this.onRefresh())
    }

    onNewRecord() {
        let that = this;
        cmn.ajaxJSON(NamaURLS.CREATE_NEW, {entityType: that.entityType}, (result) => {
            let record = result.data;
            let editPlace = new EditPlace({parentPlace: that.place, copyFromPlace: true});
            let menuLine = getMenuLineBySrc(that.place.src);
            if (menuLine && menuLine.target && menuLine.target.defaultsTemplate && menuLine.target.defaultsTemplate.id)
                editPlace.templateId = menuLine.target.defaultsTemplate.id;
            editPlace.entityType = that.entityType;
            editPlace.view = ViewMode.NEW;
            NamaRouterInstance.goTo(editPlace);
        });
    }


    calcFilteringCriteria() {
        let that = this;
        if (that.view.criteriaWidget && that.view.criteriaWidget.calcCriteria())
            return that.view.overrideCriteria(that.view.criteriaWidget.calcCriteria().build());
        if (that.place.criteria)
            return that.view.overrideCriteria(new CriteriaExpressionSerializer().criteriaFromURL(that.place.criteria).build());
        return null;
    }

    getFilledQuestionFields(list) {
        let that = this;
        if (that.place.questions) {
            return that.view.overrideQuestionFields(new QuestionFieldsSerializer().questionsFromURL(that.place.questions));
        }
        else if (that.place.listViewName) {
            let questions = that.view.filledQuestionFields;
            that.place.questions = new QuestionFieldsSerializer().toURL(questions);
            return that.view.overrideQuestionFields(questions, list);
        }
    }

    getOrderBy() {
        let that = this;
        if (!that.place.sortBy) {
            if (!that.listLayout || !that.listLayout.defaultOrderBy)
                return metadata.getCachedOrderBy(that.entityType, that.place.listViewName);
            else
                return that.listLayout.defaultOrderBy;
        }
        else {
            return that.place.sortBy;
        }
    }

    getDisplayColumns() {
        let that = this;
        if (that.view && that.view.displayColumns)
            return that.view.displayColumns.map((c) => c.id);
        return metadata.getCachedDisplayedColumns(that.entityType, that.place.listViewName);
    }

    get embeddedListView() {
        if (this.embeddedListLayoutWrapper)
            return true;
        else
            return false;
    }

    getExtraCriteria() {
        let that = this;
        let criteriaList = [];
        criteriaList.push(that.getTreeViewExtraCriteria());
        criteriaList.push(that.getReportDefinitionGroupCriteria());
        let menuCriteria = that.getMenuViewExtraCriteria();
        if (menuCriteria && menuCriteria.expressions) {
            let menuViewExtraCriteria = new JSCriteriaBuilder();
            menuViewExtraCriteria.expressions = menuCriteria.expressions;
            criteriaList.push(menuViewExtraCriteria);
        }
        let criteria = getFirstNotNullObj(...criteriaList);
        if (!criteria)
            return null;
        criteriaList.splice($.inArray(criteria, criteriaList), 1);
        for (let c of criteriaList) {
            if (c)
                criteria.join(c);
        }
        return criteria;
    }

    getReportDefinitionGroupCriteria() {
        let that = this;
        let rootType = that.place.params.get("rootType");
        if (!rootType)
            return null;
        if (areNotEqual(rootType, BSEntities.ReportGroup))
            return null;
        let criteriaBuilder = new JSCriteriaBuilder();
        criteriaBuilder.field(DomainBaseFieldIDs.ReportDefinition_groupsIds).contains(that.place.currentRoot.replace("-", ""));
        return criteriaBuilder.build();
    }

    getMenuViewExtraCriteria() {
        let that = this;
        let line = getMenuLineBySrc(that.place.src);
        return !line ? null : line.target.fetchedCriteria;
    }

    getTreeViewExtraCriteria() {
        let that = this;
        if (that.place.rootType && !that.treeView) {
            that.view.initSplitter(true, () => {
                that.view.showTreeView();
                that.treeView.selectNode(that.place.currentRoot);
            });
        }
        if (this.hasTree() && that.treeView) {
            let criteria = that.treeView.getCriteria();
            criteria.ownerType = that.entityType;
            return criteria;
        }
        else
            return null;
    }

    fetchFromServer(options) {
        let that = this;
        if(that.lastFetchedResultForPageSizeChange ){
            let x = that.lastFetchedResultForPageSizeChange;
            that.lastFetchedResultForPageSizeChange = undefined;
            if(options)
                options.success(x);
            return;
        }
        let place = that.place;
        place.pageSize = that.view.dataSource.totalPages() === 1 && !options.data.pageSize ? -1 : options.data.pageSize;
        if (that.view.criteriaWidget && that.view.criteriaWidget.calcCriteria())
            place.criteria = new CriteriaExpressionSerializer().toURL(that.view.criteriaWidget.calcCriteria());
        place.currentPage = options.data.page - 1;
        if (!that.embeddedListView)
            that._updateHistoryURL();
        let listOfQuestionFields;
        if (that.preferences.listLayout != null)
            listOfQuestionFields = that.preferences.listLayout.questionFields;
        else
            listOfQuestionFields = [];
        /**
         *
         * @type {namaTypes.ListRequest}
         */
        let req = {
            startPage: place.currentPage,
            pageSize: place.pageSize,
            owner: {
                ownerType: "Entity",
                ownerId: that.entityType
            },
            entityType: that.entityType,
            criteria: that.calcFilteringCriteria(),
            listId: that.place.listViewName,
            orderBy: that.getOrderBy(),
            ascending: that.place.ascending + "",
            displayedColumns: that.getDisplayColumns(),
            questionFields: that.getFilledQuestionFields(listOfQuestionFields),
            guessMissingMetaData: that.hasMissingMetaData,
            extraCriteria: that.getExtraCriteria(),
            extraCriteriaId: that.place.extraCriteria
        };
        let request = {
            request: JSON.stringify(req)
        };
        that.updateCache(req);
        cmn.ajaxJSONWithoutWait(NamaURLS.LIST_ENTITIES, request, (data) => {
            prepareDataParents(data);
            that.view.page = data.page;
            if (that.place.pageSize === -1 && data.pageSize != data.totalRecordsCount && data.pageSize != that.place.pageSize) {
                options.data.pageSize = data.pageSize;
                that.lastFetchedResultForPageSizeChange = data;
                that.view.dataSource.pageSize(data.pageSize);
            }

            if (options) {
                if (data.processedColumnsMetaData)
                    that.fillMissingMetadata(data.processedColumnsMetaData);
                options.success(data);
            } else {
                that.view.onDataFetched(data);
            }
        });
    }

    updateCache(request) {
        let that = this;
        let preferences = nama.cache.preferences.get(that.entityType);
        if (!preferences) {
            preferences = {};
            nama.cache.preferences.set(that.entityType, preferences);
        }
        let listLayoutPreferences = {};
        listLayoutPreferences.questionFields = request.questionFields;
        listLayoutPreferences.criteria = request.criteria;
        listLayoutPreferences.sortBy = request.orderBy;
        listLayoutPreferences.pageSize = request.pageSize;
        listLayoutPreferences.displayedColumns = request.displayedColumns;
        preferences.listLayoutPreferences = listLayoutPreferences;
    }

    fillMissingMetadata(processedColumnsMetaData) {
        let that = this;
        /**
         *
         * @type {namaTypes.ListEntityResult}
         */
        if (that.hasMissingMetaData && processedColumnsMetaData) {
            that.hasMissingMetaData = false;
            for (let column of that.preferences.listLayout.displayColumns) {
                if (!column.metaData) {
                    let colMetadata = that.findMissingMetadataByColID(processedColumnsMetaData, column.id);
                    if (colMetadata) {
                        column.metaData = colMetadata;
                    }
                    else
                        that.hasMissingMetaData = true;
                }
            }
        }
    }

    findMissingMetadataByColID(columnsMetadata, colId) {
        for (let colMetadata of columnsMetadata) {
            if (colMetadata.fieldId === colId)
                return colMetadata;
        }
        return null;
    }

    _updateHistoryURL() {
        NamaRouterInstance.updateHistoryURLSilently(this.place);
    }

    get entityType() {
        return this.place.entityType;
    }

    isRecordNotSaved() {
        return false;
    }

    hasTree() {
        let that = this;
        return that.isShowingTree() && that.supportsTreeInListView();
    }

    supportsTreeInListView() {
        let that = this;
        if (ClientCache.isMasterFile(that.entityType))
            return true;
        return false;
    }

    isShowingTree() {
        let that = this;
        let listLayout = that.preferences.listLayout;
        let showTree = that.place.showTree;
        if (that.place.rootType)
            return true;
        if (!showTree && listLayout && listLayout.showTreeViewByDefault)
            return true;
        return showTree === "true" || showTree === true;
    }

    callGUIAction(actionId, metaData, actionCustomization) {
        new ActionHandler(of(actionId, actionCustomization), this.entityType, metaData, new ActionPerformer()).performAction(this);
    }
    onListView(){
        this.onRefresh();
    }
    onRefresh() {
        this.view.refresh();
    }

    addContextFieldsToAction(requester, allContextFieldsIds, row, contextFields,
                             fromGridAction, allSumsIds, sums, presenter) {
        let that = this;
        if (allContextFieldsIds.contains(CommonFieldIds.LIST_VIEW_SELECTED_IDS)) {
            let selectedRowsIds = presenter.view.getSelectedRowsId();
            contextFields[CommonFieldIds.LIST_VIEW_SELECTED_IDS] = createGenericValueForList(CommonFieldIds.LIST_VIEW_SELECTED_IDS, selectedRowsIds, "java.lang.String");
        }
        if (allContextFieldsIds.contains(CommonFieldIds.LIST_VIEW_PAGE_IDS)) {
            let pages = presenter.view.page;
            let pagesIds = [];
            for (let page of pages) {
                pagesIds.push(page.values["id"]);
            }
            contextFields[CommonFieldIds.LIST_VIEW_PAGE_IDS] = createGenericValueForList(CommonFieldIds.LIST_VIEW_PAGE_IDS, pagesIds, "java.lang.String");
        }
        if (allContextFieldsIds.contains(CommonFieldIds.LIST_VIEW_CRITERIA)) {
            contextFields[CommonFieldIds.LIST_VIEW_CRITERIA] = createGenericValueForObject(CommonFieldIds.LIST_VIEW_CRITERIA, presenter.calcFilteringCriteria(), null, "com.namasoft.common.criteria.DTOCriteria");
        }
        for (let field of allContextFieldsIds) {
            if (field !== CommonFieldIds.LIST_VIEW_SELECTED_IDS && field.startsWith(CommonFieldIds.LIST_VIEW_SELECTED_IDS)) {
                let selectedRows = presenter.view.getSelectedRows();
                that.addFields(field.substring(CommonFieldIds.LIST_VIEW_SELECTED_IDS.length), field, contextFields, selectedRows, presenter);

            } else if (field !== CommonFieldIds.LIST_VIEW_PAGE_IDS && field.startsWith(CommonFieldIds.LIST_VIEW_PAGE_IDS)) {
                let pagesIds = presenter.view.page;
                that.addFields(field.substring(CommonFieldIds.LIST_VIEW_PAGE_IDS.length), field, contextFields, pagesIds, presenter);
            }
        }

    }

    addFields(fieldId, contextFieldId, contextFields, rows, presenter) {
        let ids = [];
        for (let row of rows) {
            ids.push(row.values[fieldId]);
        }
        if (!Array.isArray(ids))
            ids = [ids];
        let displayColumn = presenter.preferences.listLayout.displayColumns.filter(c => c.id == fieldId)[0];
        if (!displayColumn)
            return;
        let fieldType = displayColumn.metaData.fieldType;
        if (fieldType == "Genericreference") {
            let oldIds = ids;
            ids = [];
            for (let id of oldIds) {
                ids.push({
                    valuesMap: id
                });
            }
            contextFields[contextFieldId] = createGenericValueForList(contextFieldId, ids, "com.namasoft.common.flatobjects.FlatObject");

        } else
            contextFields[contextFieldId] = list(contextFieldId, ids);

    }

    onPrint(format) {
        let that = this;
        isPrintingPossible({
                printingOption: PrintingOption.NONE, format: format,
                entityType: that.entityType,
                viewName: that.view.id,
                menuCode: that.place.src
            }, () => printList(that.entityType, that.view.getSelectedRowsId(), format, that.view.id, 0, that.place.src)
        )
    }

    getTreeView() {
        return this.view.rootElement.find("#treeView");
    }

    sendEmail() {
        let that = this;
        isPrintingPossible({
            printingOption: PrintingOption.NONE, format: OutputFormat.PDF,
            entityType: that.entityType,
            viewName: that.view.id, menuCode: that.place.src
        }, () => sendEmail_(format, that.entityType, toCSVLineWithSep(",", that.view.getSelectedRowsId()), null, that.view.id, that.place.src, false, that))
    }

    businessFunctions() {
        let that = this;
        if (that.idsWithActions)
            return that.idsWithActions;
        that.idsWithActions = super.businessFunctions();
        that.idsWithActions[BusinessFunction.treeView] = () => that.view.showTreeView();
        that.idsWithActions[BusinessFunction.listView] = () => that.onListView();
        that.idsWithActions[BusinessFunction.resultSettings] = () => that.view.showResultSettingsWindow();
        that.idsWithActions[BusinessFunction.more] = () => that.view.showMoreMenu();
        that.idsWithActions[BusinessFunction.newRecord] = () => that.onNewRecord();
        that.idsWithActions[BusinessFunction.revise] = () => that.revise(that.view.getSelectedRowsId());
        that.idsWithActions[BusinessFunction.unrevise] = () => that.unRevise(that.view.getSelectedRowsId());
        that.idsWithActions[BusinessFunction.$delete] = () => that.unRevise(that.view.deleteAction());
        that.idsWithActions[BusinessFunction.sendEmailWithResult] = () => that.unRevise(that.view.deleteAction());
        that.idsWithActions[BusinessFunction.exportAsPDF] = () => that.onPrint(OutputFormat.PDF);
        that.idsWithActions[BusinessFunction.exportAsPPTX] = () => that.onPrint(OutputFormat.PPTX);
        that.idsWithActions[BusinessFunction.exportAsODS] = () => that.onPrint(OutputFormat.ODS);
        that.idsWithActions[BusinessFunction.exportAsODT] = () => that.onPrint(OutputFormat.ODT);
        that.idsWithActions[BusinessFunction.exportAsXLS] = () => that.onPrint(OutputFormat.XLS);
        that.idsWithActions[BusinessFunction.exportAsXLSX] = () => that.onPrint(OutputFormat.XLSX);
        that.idsWithActions[BusinessFunction.exportAsRTF] = () => that.onPrint(OutputFormat.RTF);
        that.idsWithActions[BusinessFunction.exportAsDOCX] = () => that.onPrint(OutputFormat.DOCX);
        that.idsWithActions[BusinessFunction.exportAsTXT] = () => that.onPrint(OutputFormat.TXT);
        return that.idsWithActions;
    }

    hasGUIAction(businessId) {
        let guiAction = findActionsWithActionId(businessId, this.metaData);
        if (!guiAction)
            return false;
        return guiAction.contextFields.contains(CommonFieldIds.LIST_VIEW_SELECTED_IDS);
    }

    getSelectedObjects(){
        return this.view.getSelectedRowsId();
    }

    getPage_(){
        return this.view.getViewRowsId();
    }

    /**
     *
     * @param {namaTypes.CustomRepInfo} customRepInfo
     */
    printUsing(customRepInfo) {
        let that = this;
        let ids;
        if (customRepInfo.selectedRecordsOnly === true)
            ids = that.getSelectedObjects();
        else
            ids = that.getPage_();
        printList(that.entityType, ids, OutputFormat.PDF, that.preferences.listLayout.id, 0, customRepInfo.reportId);
    }

    viewName_() {
        let that = this;
        return that.place.listViewName;
    }

    getHiddenQuestionsInListView(entityType, listViewName) {
        if (areEqual(entityType, BSEntities.ApprovalDefinition)
            && isAnyEqualToFirst(listViewName, ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME,
                ConstantViewNames.EMPLOYEE_READ_NOTIFICATIONS_SCREEN_NAME))
            return ["employee", "userId"];
        return [];
    }
}
